<template>
<div class="chapter">
<div class="inner_page">
<h1 class="basic-paragraph"> </h1>
<p class="firstparagraph"><em class="italic">Notice to the Reader</em></p>
<p class="basic-paragraph">Foreign words and unfamiliar technical terms are explained briefly in the glossary in the back of the book.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TheEyesOfVenice_00000.vue?19a8bc10